import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { useExperimentEnrichmentContext } from '~/features/content-enrichment/adapters/experiment-enrichment-adapter';
import { EnrichmentCtx } from '~/features/content-enrichment/context/enrichment-context';
import { RequireChannelConnection } from '~/features/onboarding/components/require-channel-connection';

const ContentEnrichmentLayout = lazy(
  () => import('~/features/content-enrichment/pages/content-enrichment-layout'),
);

/**
 * Thin provider wrapper that builds the experiment-specific EnrichmentContext
 * and injects it into the funnel tree. Keeps the route file responsible only
 * for wiring — all experiment logic lives in the adapter hook.
 */
function ExperimentContentEnrichmentProvider() {
  const ctx = useExperimentEnrichmentContext();
  return (
    <EnrichmentCtx.Provider value={ctx}>
      <ContentEnrichmentLayout />
    </EnrichmentCtx.Provider>
  );
}

/** Content-enrichment funnel scoped to a specific experiment. URL: `/experiments/{expId}/content-enrichment/...`. */
export const Route = createFileRoute(
  '/_authenticated/_tenant/experiments_/$expId/content-enrichment',
)({
  component: () => (
    <RequireChannelConnection>
      <Suspense fallback={<PageSkeleton />}>
        <ExperimentContentEnrichmentProvider />
      </Suspense>
    </RequireChannelConnection>
  ),
});
